import { useEffect, useRef, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { useRouteServerErrorRegistration } from '@/config/routeServerError';
import { DASHBOARD, INVITE, LOGIN } from '@/constants/routes';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import Error from '@/pages/Error';
import { clearAuthSessionStorage, getAccessToken } from '@/utils/localStorage';

const PublicRoute = () => {
  const [error, setError] = useState(false);
  const location = useLocation();
  const onLoginPath = location.pathname === LOGIN;
  const { isAuth } = useCurrentUser();
  const clearedStickySessionRef = useRef(false);

  // Recover from sticky auth/workspace headers that can block CORS login.
  // Clear even when access_token is already gone — X-Recruiter-Company-Id alone
  // is enough for the browser to fail the preflight Allow-Headers check.
  useEffect(() => {
    if (!onLoginPath) {
      clearedStickySessionRef.current = false;
      return;
    }
    setError(false);
    if (!isAuth && !clearedStickySessionRef.current) {
      clearedStickySessionRef.current = true;
      clearAuthSessionStorage();
    }
  }, [onLoginPath, isAuth]);

  useRouteServerErrorRegistration(setError);

  // Allow /login through even if a prior 5xx flipped the route error flag.
  if (error && !onLoginPath) {
    return <Error />;
  }

  const token = getAccessToken();
  if (token && !onLoginPath && !location.pathname.startsWith(INVITE)) {
    return <Navigate to={DASHBOARD} replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
